// removed by extract-text-webpack-plugin
module.exports = {"errors":"_3KkrI","errors-svg":"_2HPxi","errors-heading":"_2gs4r","errors-body":"T7-G1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Error/less/error.less
// module id = ./src/components/Error/less/error.less
// module chunks = 4